import { render } from "./day-charts.vue?vue&type=template&id=fa9810f4"
import script from "./day-charts.vue?vue&type=script&lang=ts"
export * from "./day-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script